module.exports = __webpack_public_path__ + "img/woshou1.dea01ad1.png";